import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LstAuthGuard, LstRouterModule } from '@savvaslearning/lst-auth';
import { ErrorComponent } from './shared/components/error/error.component';
import { StandaloneMultiStageGrowthReportResolver } from './shared/resolver/standalone-growth-report.resolver';

const routes: Routes = [
  {
    path: 'classes/:classId/root-program-id/:rootProgramId',
    canActivate: [LstAuthGuard],
    resolve: { data: StandaloneMultiStageGrowthReportResolver },
    loadChildren: () =>
      import('./multi-stage-growth-report/multi-stage-growth-report.module').then(
        (m) => m.MultiStageGrowthReportModule,
      ),
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  { path: '**', redirectTo: 'error' },
];

@NgModule({
  imports: [LstRouterModule.getRoutes(), RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
